// Shows ther user's information, including their cards, contact information, and subscription details.

import CardsList  from '../components/stripe/CardsList';
import SubscriptionDetails from '../components/SubscriptionDetails';
import ContactInfo from '../components/ContactInfo'


const UserInfo = () => {
  return (
    <div className="min-h-screen bg-bg px-4 py-6 sm:px-6 lg:px-8">
      <div className='mx-auto w-full max-w-5xl space-y-6'>
        <header className="rounded-2xl border border-border bg-surface p-5 shadow-sm">
          <h1 className="text-card-title font-semibold tracking-tight text-ink">Account & Billing</h1>
          <p className="mt-1 text-body text-ink-2">Manage payment methods, contact details, and subscription settings.</p>
        </header>

        <div className='rounded-2xl border border-border bg-surface p-5 shadow-sm'>
          <CardsList />
        </div>

        <div className='rounded-2xl border border-border bg-surface p-5 shadow-sm'>
          <ContactInfo />
        </div>

        <div className='rounded-2xl border border-border bg-surface p-5 shadow-sm'>
          <SubscriptionDetails />
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
